import { createFileRoute, useParams } from '@tanstack/react-router';

import { EnrollmentsTab } from '@/views/admin/courses/tabs/enrollments-tab.tsx';

export const Route = createFileRoute('/admin/courses_/$id/enrollments')({
  component: EnrollmentsRoute,
});

function EnrollmentsRoute() {
  const { id } = useParams({ from: '/admin/courses_/$id/enrollments' });
  return <EnrollmentsTab id={id} />;
}
